import React, { useState, useEffect } from 'react';
import styles from '@/pages/camp/components/css/campCSS.less';
import { useRequest } from 'umi';
import { listNodeLog } from '@/utils/requests/camp/requests_admin';
import { NodeLogListVO } from '@/types/camp/admin/studentType';
import { Table } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import dayjs from 'dayjs';
import { formatVideoDuration, formatDurationSimple } from '@/pages/camp/util/indexUtil';
import { NodeStudyStateToText } from '@/pages/camp/util/campState';
import { NodeStudyState } from '@/types/camp/study/index';
import useScrollHeight from '@/hooks/useScrollHeight';

interface Props {
  batchId: string;
  signUpId: string;
}
const NodeLog: React.FC<Props> = ({ batchId, signUpId }) => {
  const [data, setData] = useState<NodeLogListVO[]>([]);
  const [loading, setLoading] = useState(true);
  const scrollHeight = useScrollHeight();

  // 获取接口
  const { run: listNodeLogRequest } = useRequest(
    () => {
      return listNodeLog(batchId, signUpId);
    },
    {
      manual: true,
      onSuccess: (res) => {
        setData(res);
        setLoading(false);
      },
    },
  );
  useEffect(() => {
    listNodeLogRequest();
  }, []);

  const columns: ColumnsType<NodeLogListVO> = [
    {
      title: '节点名称',
      dataIndex: 'name',
      key: 'name',
      width: '30%',
    },
    {
      title: '打卡状态',
      dataIndex: 'studyState',
      key: 'studyState',
      render: (value, record) =>
        record.studyState === NodeStudyState.NODE_FAIL && !record?.sumDuration ? (
          <span className="colc0c">未打卡</span>
        ) : (
          <NodeStudyStateToText state={value} />
        ),
    },
    {
      title: '打卡总耗时',
      dataIndex: 'sumDuration',
      key: 'sumDuration',
      render: (value: any) => (value ? formatVideoDuration(value) : '--'),
    },
    {
      title: '开始打卡时间',
      key: 'campStartTimeKey',
      render: (value, record) => {
        return (
          <div className="col595">
            {record.nodeLogList && record.nodeLogList.length > 0
              ? record.nodeLogList.map((item, index) => (
                  <p key={index}>{dayjs(item.createdTime).format('YYYY-MM-DD HH:mm')}</p>
                ))
              : '--'}
          </div>
        );
      },
    },
    {
      title: '打卡耗时',
      dataIndex: 'nodeLogList',
      key: 'nodeLogList',
      render: (value, record) => {
        return (
          <div className="col595">
            {record.nodeLogList && record.nodeLogList.length > 0
              ? record.nodeLogList.map((item, index) => (
                  <p key={index}>{formatDurationSimple(item.duration)}</p>
                ))
              : '--'}
          </div>
        );
      },
    },
    {
      title: '完成打卡时间',
      dataIndex: 'submitTime',
      key: 'submitTime',
      render: (value: any) => (value ? `${dayjs(value).format('YYYY-MM-DD HH:mm')}` : '--'),
    },
  ];
  return (
    <div>
      <Table
        rowKey={(record) => record.id}
        columns={columns}
        dataSource={data}
        loading={loading}
        pagination={false}
        className={styles.study_log_table}
        scroll={{ y: scrollHeight }}
      />
    </div>
  );
};
export default NodeLog;
